import { useEffect, useState } from "react";
import { Search, User, ShoppingBag, Menu, X, Calendar } from "lucide-react";
import { NAV_LINKS } from "../mock";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 w-full bg-white/85 backdrop-blur-md transition-all duration-500 ${
        scrolled ? "border-b border-black/10" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-[76px] flex items-center justify-between">
        <a href="#" className="flex items-center gap-2">
          <span className="display text-2xl font-extrabold tracking-tight">
            Hire<span className="text-[#0a0a0a]">Me</span>
            <span className="text-[#0a0a0a]">.</span>
          </span>
          <span className="handwritten text-2xl text-[#0a0a0a] -ml-1">studio</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="link-underline text-[15px] font-medium text-[#0a0a0a] hover:text-black"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <button
            data-book
            className="h-10 px-4 rounded-full border border-black/15 text-sm font-medium hover:border-black hover:bg-neutral-50 transition-colors flex items-center gap-1.5"
          >
            <Calendar size={14} />
            Book Call
          </button>
          {/* <button
            aria-label="Search"
            className="w-10 h-10 rounded-full border border-black/10 flex items-center justify-center hover:bg-black hover:text-white transition-colors"
          >
            <Search size={17} />
          </button> */}
          {/* <button
            aria-label="Profile"
            className="w-10 h-10 rounded-full border border-black/10 flex items-center justify-center hover:bg-black hover:text-white transition-colors"
          >
            <User size={17} />
          </button> */}
          <a
            href="#contact"
            className="h-10 pl-5 pr-2 rounded-full bg-black text-white flex items-center gap-2 text-sm font-medium hover:bg-neutral-800 transition-colors group"
          >
            Hire Me
            <span className="w-7 h-7 rounded-full bg-[#FFE14D] text-black flex items-center justify-center group-hover:rotate-45 transition-transform">
              <ShoppingBag size={14} />
            </span>
          </a>
        </div>

        <button
          className="md:hidden w-10 h-10 rounded-full border border-black/10 flex items-center justify-center"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/10 bg-white">
          <div className="px-6 py-5 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[16px] font-medium"
              >
                {l.label}
              </a>
            ))}
            <button
              data-book
              onClick={() => setOpen(false)}
              className="h-11 rounded-full border-2 border-black flex items-center justify-center gap-2 text-sm font-medium mt-2"
            >
              <Calendar size={14} /> Book a free call
            </button>
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="h-11 rounded-full bg-black text-white flex items-center justify-center gap-2 text-sm font-medium"
            >
              Hire Me
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
